import { render, staticRenderFns } from "./Brand.vue?vue&type=template&id=c2786bfe&scoped=true&"
import script from "./Brand.vue?vue&type=script&lang=js&"
export * from "./Brand.vue?vue&type=script&lang=js&"
import style0 from "./Brand.vue?vue&type=style&index=0&id=c2786bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2786bfe",
  null
  
)

export default component.exports